"use client";
import './assets/Offer.css';const _ = "_offer_yleoj_1", e = "__children_yleoj_15", o = "__pointer_yleoj_18", t = "_friday_yleoj_30", n = "_friday2024_yleoj_33", c = "_darkblue_yleoj_36", l = "_instagram_yleoj_40", i = "_covered_yleoj_43", r = "_image_yleoj_47", s = "_content_yleoj_63", y = "_title_yleoj_71", a = "_text_yleoj_79", j = "_text__bold_yleoj_86", d = "_close_yleoj_92", f = "_timer_yleoj_116", m = "_orange_yleoj_127", b = "_white_yleoj_131", g = "_pink_yleoj_135", p = "__active_yleoj_139", x = "_number_yleoj_143", h = "_notice_yleoj_160", k = "_colon_yleoj_166", u = {
  offer: _,
  _children: e,
  _pointer: o,
  friday: t,
  friday2024: n,
  darkblue: c,
  instagram: l,
  covered: i,
  image: r,
  content: s,
  title: y,
  text: a,
  text__bold: j,
  close: d,
  timer: f,
  orange: m,
  white: b,
  pink: g,
  _active: p,
  number: x,
  notice: h,
  colon: k
};
export {
  u as s
};
